import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { DeviceAuthProvider } from './context/DeviceAuthContext';
import { CartProvider } from './context/CartContext';
import { AdminAuthProvider } from './context/AdminAuthContext';
import HomePage from './pages/HomePage';
import VideoSelectionPage from './pages/VideoSelectionPage';
import CheckoutPage from './pages/CheckoutPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentFailurePage from './pages/PaymentFailurePage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminPage from './pages/AdminPage';
import CreateAdminPage from './pages/CreateAdminPage';
import DeviceProtectedRoute from './components/Auth/DeviceProtectedRoute';
import AdminRoute from './components/Auth/AdminRoute';
import SuperAdminRoute from './components/Auth/SuperAdminRoute';
import './styles/root.css';
import './styles/App.css';

const App: React.FC = () => {
  return (
    <DeviceAuthProvider>
      <CartProvider>
        <AdminAuthProvider>
          <Router>
            <div className="app">
              <main className="main-content">
                <Switch>
                  <Route exact path="/">
                    <Redirect to="/box" />
                  </Route>
                  <Route exact path="/box" component={HomePage} />
                  <DeviceProtectedRoute path="/box/video-selection" component={VideoSelectionPage} />
                  <DeviceProtectedRoute path="/box/checkout" component={CheckoutPage} />
                  
                  {/* Staging routes */}
                  <Route exact path="/staging">
                    <HomePage isStaging={true} />
                  </Route>
                  <DeviceProtectedRoute 
                    path="/staging/video-selection" 
                    component={(props: any) => <VideoSelectionPage {...props} isStaging={true} />} 
                  />
                  <DeviceProtectedRoute 
                    path="/staging/checkout" 
                    component={(props: any) => <CheckoutPage {...props} isStaging={true} />} 
                  />
                  
                  <Route path="/payment/success" component={PaymentSuccessPage} />
                  <Route path="/payment/failure" component={PaymentFailurePage} />
                  <Route path="/admin/login" component={AdminLoginPage} />
                  <AdminRoute path="/admin/dashboard" component={AdminPage} />
                  <SuperAdminRoute path="/admin/create" component={CreateAdminPage} />
                  <Redirect to="/box" />
                </Switch>
              </main>
            </div>
          </Router>
        </AdminAuthProvider>
      </CartProvider>
    </DeviceAuthProvider>
  );
};

export default App;